export interface RoutesState {
    isUrlPublic:boolean,
}

export const initialRoutesState: RoutesState = {
    isUrlPublic: false,
}